// extracted by mini-css-extract-plugin
module.exports = {"saveMsgWrapper":"display-message_saveMsgWrapper__32y_B"};